<template>
    <v-app :id="(((finalizado == true) && (revelaType == 'FS') || (encerrado == true)) && (sexo == 'F'))?'teste-template-f':(((finalizado == true) && (revelaType == 'FS') || (encerrado == true)) && (sexo == 'M'))?'teste-template-m':'teste-template'">        
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ=" crossorigin="anonymous" />
        <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
            <span> {{snackbar.message}} </span>
            <v-btn text @click="snackbar.active = false">Close</v-btn>
        </v-snackbar>  
        <v-row justify="center" align-content="center">
            <v-col cols="12" class="text-center my-4">
                <v-carousel cycle height="60" interval="15000" hide-delimiter-background hide-delimiters show-arrows-on-hover >
                    <v-carousel-item v-for="(slide, i) in this.babyData.mensagens" :key="i">
                    <!-- <v-sheet height="100%"> -->
                        <v-row align="center" justify="center" >
                            <div class="text-h6">{{ slide.mensagem }} - {{ slide.nome }}</div>
                        </v-row>
                    <!-- </v-sheet> -->
                    </v-carousel-item>
                </v-carousel>                                               
            </v-col> 
        </v-row>        
        <v-row v-if="(typeof this.babyData.id != 'undefined')" justify="center" align-content="center">
            <preRevelation v-if="(finalizado == false && encerrado == false)" :babyData="babyData" @loadMessage="loadMessage" @startCha="startCha"/>   
            <revelationSite v-if="(finalizado == true && revelaType == 'FS' && encerrado == false)" :babyData="babyData" @loadMessage="loadMessage"/>
            <revelationJitsi v-if="(finalizado == true && revelaType == 'CV' && encerrado == false)" :babyData="babyData" @loadMessage="loadMessage"/>   
            <revelationFinish v-if="(encerrado == true)" :babyData="babyData"/>  
        </v-row>
        <v-row justify="center" align-content="center">
            <v-col cols="12" class="text-center">
                <p class="subheading font-weight-regular">
                    Compartilhe em suas Redes Sociais
                    <!-- <countdown :time="ct2" @end="closedCha">        
                        <template slot-scope="props">
                            <span> 
                            {{ props.days }} - {{ props.hours }} - {{ props.minutes }} - {{ props.seconds }} 
                            </span>
                        </template>
                    </countdown> -->
                </p>                                                
            </v-col>
            <v-col cols="12">                       
                <div class="share-network-list">
                    <ShareNetwork
                        v-for="network in networks"
                        :network="network.network"
                        :key="network.network"
                        :style="{backgroundColor: network.color}"
                        :url="sharing.url"
                        :title="network.title"
                        :description="sharing.description"
                        :quote="sharing.quote"
                        :hashtags="sharing.hashtags"
                        :twitterUser="sharing.twitterUser"
                    >
                        <v-icon dark>{{network.icon}}</v-icon>
                        <span>{{ network.name }}</span>                        
                    </ShareNetwork> 
                </div> 
            </v-col>   
        </v-row>
    </v-app>
</template>
<script src='https://meet.jit.si/external_api.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>
import * as firebase from "firebase"
import presentear from "@/components/presentearComponent"
import mensagem from "@/components/messagePage"
import preRevelation from "./preRevelation"
import revelationSite from "./revelationSite"
import revelationJitsi from "./revelationJitsi"
import revelationFinish from "./revelationFinish"
import {db} from '@/main.js'

export default {
    components:{presentear,mensagem, preRevelation, revelationSite, revelationJitsi, revelationFinish},
    data: () => ({
        url: '',
        babyData: '',
        key: 0,
        db: '',
        contagem: new Date().getTime(),
        votosMenino: 0,
        votosMenina: 0,
        loading: false,
        finalizado: false,
        room: '',
        userName: '',
        revelaType: '',
        sexo: '',
        nomeReal: '',
        revelationId: '',
        encerrado: false,
        ct2: new Date().getTime() + 7200000,
       colors: [
          '#54c6fc',
          '#73bef4',
          '#89b9ef',
          '#baace2',
          '#cba7de',
          '#dea2d9',
          '#cba7de',
          '#cba7de',

        ],       
        sharing: {
            url: '',
            title: 'Venha participar conosco desse momento tão especial, acesse o link abaixo do Chá Revelação: ',
            titletwitter: 'Venha participar conosco desse momento tão especial, acesse o link do Chá Revelação: ',
            description: 'This week, I’d like to introduce you to "Vite", which means "Fast". It’s a brand new development setup created by Evan You.',
            quote: 'The hot reload is so fast it\'s near instant. - Evan You',
            hashtags: 'charevelação,bebe,gravida,convite',
            // twitterUser: 'youyuxi'
        },        
        snackbar: {
            'active':false,
            'color':'success',
            'message':'Mensagem Salva com Sucesso.'
        }        
    }),  
    async created(){
        this.finalizado = false;
        await setTimeout(()=>{}, 5000);
        this.url = this.$route.params.pathURL;
        
        console.log("babydata", this.url)

        await db.collection('revelacoes').where('URL','==',this.url).get()
        .then((seg) => {    
            this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a});                    
            //  console.log("babydata", this.babyData)

            if (this.babyData.length == 1)
                this.babyData = this.babyData[0]  

            this.key += 1
            this.revelationId = this.babyData.id
            // console.log("babydata", this.babyData)

            this.babyData.contagem = this.babyData.dataRevelacao - new Date().getTime()
            
            this.ct2 = (this.babyData.dataRevelacao + 7200000) - new Date().getTime()

            this.revelaType = this.babyData.tipoRevelacao
            this.encerrado = this.babyData.encerrado || false
            let nomeMano = this.babyData.nomeMenino
            let nomeMina = this.babyData.nomeMenina

            this.sexo = this.babyData.sexo
            this.babyData.FirstNameMenino =  nomeMano.substring(0, (nomeMano.indexOf(" ") >= 0)? nomeMano.indexOf(" ") : nomeMano.length)
            this.babyData.FirstNameMenina =  nomeMina.substring(0, (nomeMina.indexOf(" ") >= 0)? nomeMina.indexOf(" ") : nomeMina.length)
            let revelationTime = this.formatDate(this.babyData.dataRevelacao)
            
            this.sharing.titletwitter = this.sharing.titletwitter + 'https://www.revelacha.com.br/access/'+this.url
            this.sharing.title = this.sharing.title + '\n \n' + 'https://www.revelacha.com.br/access/'+this.url

            this.sharing.quote =  'Sonhamos e esperamos com esse dia, e então chegou a hora de sabermos se é a ' + this.babyData.FirstNameMenina + ' ou o ' + this.babyData.FirstNameMenino + ' que está a caminho. Convido vocês a participarem mesmo que virtualmente do nosso Chá Revelação, no dia '+ revelationTime.data + ' às ' + revelationTime.time + '. Vamos descobrir juntos?'            
            this.sharing.description = 'Sonhamos e esperamos com esse dia, e então chegou a hora de sabermos se é a ' + this.babyData.FirstNameMenina + ' ou o ' + this.babyData.FirstNameMenino + ' que está a caminho. Convido vocês a participarem mesmo que virtualmente do nosso Chá Revelação, no dia '+ revelationTime.data + ' às ' + revelationTime.time + '. Vamos descobrir juntos?'

        }).catch(function (error) {
            console.error("Error get userss: ", error);
        });          
    },   
    computed:{
        networks(){
            return  [
            { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2', title: this.sharing.title },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366', title: this.sharing.title},
            { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2', title: this.sharing.titletwitter },
            { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc', title: this.sharing.title },            
        ]
        }        
    },
    methods:{  
        loadMessage(){
            this.snackbar.active = true
        }, 
        async closedCha(){
            await setTimeout(()=>{}, 5000);

            let info = {
                'encerrado': true,
            }
            console.log(this.babyData.id)
            db.collection('revelacoes').doc(this.babyData.id).update(info).then(async() => {
                // this.loading = false
                this.encerrado = true
                // console.log('Votos Salvo')
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })              
        },
        formatDate(time){
            let data = new Date(time)
            let retorno = {
            'data': '',
            'time': ''
            }
            let month = data.getMonth() + 1
            retorno.data = ('0' + data.getDate()).slice(-2) + '/'
                + ('0' + (month)).slice(-2) + '/'
                + data.getFullYear()

            retorno.time = data.getHours() + ':' + ('0'+data.getMinutes()).slice(-2)
            return retorno 
        },          
        async startCha(){
            console.log('acabou')
            this.finalizado = true
            await this.loadVotos()
            // await setTimeout(()=>{}, 5000);
            // if (this.revelaType == 'CV')
            //     this.startConference();          
        },
        async loadVotos(){
            await db.collection('revelacoes').where('URL','==',this.url).get()
            .then((seg) => {    
                this.votosMenino = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a[0].votosMenino || 0});                    
                this.votosMenina = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a[0].votosMenina || 0});                                    
            }).catch(function (error) {
                console.error("Error get Votos: ", error);
            }); 
        },
        async votoMenino(){
            await this.loadVotos()
            this.votosMenino += 1
            let infoVoto = {
                'votosMenino': this.votosMenino,
                'votosMenina': this.votosMenina
            }

            db.collection('revelacoes').doc(this.babyData.id).update(infoVoto).then(async() => {
                this.loading = false
                // console.log('Votos Salvo')
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })             
        },
        async votoMenina(){
            await this.loadVotos()
            this.votosMenina += 1
            let infoVoto = {
                'votosMenino': this.votosMenino,
                'votosMenina': this.votosMenina
            }

            db.collection('revelacoes').doc(this.babyData.id).update(infoVoto).then(async() => {
                this.loading = false
                // console.log('Votos Salvo')
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })             
        },
        createFirebase(){
            const firebaseConfig = {
                apiKey: "AIzaSyBkZBJY36Csg1dSWopBEZhceIfSz1zObSY",
                authDomain: "revelacha.firebaseapp.com",
                databaseURL: "https://revelacha.firebaseio.com",
                projectId: "revelacha",
                storageBucket: "revelacha.appspot.com",
                messagingSenderId: "681268845746",
                appId: "1:681268845746:web:47df592430fa858496fdab",
                measurementId: "G-PZYQ3LJC2K"
            };

            firebase.initializeApp(firebaseConfig); 
            
            return firebase.firestore()
        },
        startConference() {
            // var _this=this
            try {
                const domain = 'meet.jit.si';
                const options = {
                    audioInput: '<deviceLabel>',
                    audioOutput: '<deviceLabel>',
                    videoInput: '<deviceLabel>',
                    roomName: this.url,
                    // height: 500,
                    parentNode: document.querySelector('#jitsi-container'),
                    interfaceConfigOverwrite: {
                        filmStripOnly: false,
                        SHOW_JITSI_WATERMARK: false,
                    },
                    configOverwrite: {
                        disableSimulcast: false,
                    },
                    userInfo: {
                        email: 'email@jitsiexamplemail.com',
                        displayName: 'this.userName'
                    }                    
                };

                this.api = new JitsiMeetExternalAPI(domain, options);
                // this.api.addEventListener('videoConferenceJoined', () => {
                //    console.log('Local User Joined');        
                //     this.api.executeCommand('displayName', this.userName);
                // });
            } catch (error) {
                console.error('Failed to load Jitsi API', error);
            }
        },     
        createNuvem(){
            let canvas = this.$refs.testecanvas;
            let context = canvas.getContext('2d');
            let ctx = canvas.getContext('2d');

            // draw cloud
            context.beginPath();
            context.moveTo(170, 80);
            context.bezierCurveTo(130, 100, 130, 150, 230, 150);
            context.bezierCurveTo(250, 180, 320, 180, 340, 150);
            context.bezierCurveTo(420, 150, 420, 120, 390, 100);
            context.bezierCurveTo(430, 40, 370, 30, 340, 50);
            context.bezierCurveTo(320, 5, 250, 20, 250, 50);
            context.bezierCurveTo(200, 5, 150, 20, 170, 80);
            context.closePath();

            context.lineWidth = 5;
            context.fillStyle = '#8ED6FF';
            context.fill();
            
            ctx.font = "16px Arial";
            ctx.fillStyle = "red";
            ctx.textAlign = "center";
            ctx.fillText("Hello World", canvas.width/2, canvas.height/2);

            context.strokeStyle = '#0000ff';
            context.stroke();

            // save canvas image as data url (png format by default)
            var dataURL = canvas.toDataURL();

            // set canvasImg image src to dataURL
            // so it can be saved as an image
            this.$refs.canvasImg.src = dataURL;
            
        }            
    },      
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Share+Tech+Mono');

#teste-template {
  height: 100% !important;
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;
}
#teste-template-f {
  height: 100% !important;
  background: #f59cd3;
  /* background-size: cover; */
}
#teste-template-m {
  height: 100% !important;
  background: #51c7fd;
  /* background-size: cover; */
}

#jitsi-container {
    height:100px
}
.font-crono {
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 5em;
    line-height: 1;
} 

@media (max-width: 380px) {
    .font-crono {
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em;
        line-height: 1;
    }; 
    .font-crono-span{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em!important;
        color: rgb(196, 29, 29)!important
    }
    .font-crono-span2{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 2.3em!important;
        color: white!important    
    }        
}

.font-crono-span{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 0.27em!important;
    color: white!important
}
.font-crono-span2{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 4.3em!important;
    color: white!important    
}

.font-crono-span-revela{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 2.3em!important;
    color: white!important    
}

v-sheet {
  background: linear-gradient(to right, #51c7fd, #f59cd3) !important;
  background-size: cover;    
  color: rgb(255, 255, 255)!important;

}
.transparent {
   background-color: white!important;
   opacity: 0;
   border-color: transparent!important;
}
.font-white{
       color: white!important;
}

 .share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF !important;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>